import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { convertAddToCartFromOrdersParams } from '@/utils/event-tracker/convertParams/convertProductParams'
import { decodeIdForEventTracker } from '@/utils/utilApi'

interface TrackClickOrderListAddToCartButtonEventProps {
  optionId: string
  optionName: string
  productId: string
  productName: string
  brandId: string
  brandName: string
  supplyType: string
}

export const useProductEventTracker = () => {
  const tracker = useTracker()
  const trackClickOrderListAddToCartButtonEvent = ({
    optionId,
    optionName,
    productId,
    productName,
    brandId,
    brandName,
    supplyType,
  }: TrackClickOrderListAddToCartButtonEventProps) => {
    const properties = {
      ...convertAddToCartFromOrdersParams({
        option_id: Number(optionId),
        optionName: optionName,
        product_id: Number(productId),
        productName: productName,
      }),
      brandId: decodeIdForEventTracker(brandId),
      brandName,
      supplyType,
    }

    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickOrderlistAddtocartButton, properties)
  }

  return {
    trackClickOrderListAddToCartButtonEvent,
  }
}
